import React from 'react'

const ChatForm = () => {
    return (
        <div>ChatForm</div>
    )
}

export default ChatForm